exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ticket__item[data-v-320fc5c8] {\n  margin-bottom: -1px;\n  padding: 17px 60px 17px 22px;\n  -webkit-transition: background-color .5s ease;\n  -o-transition: background-color .5s ease;\n  transition: background-color .5s ease;\n}\n.ticket__item[data-v-320fc5c8]:hover {\n  background-color: rgba(194, 194, 194, 0.3);\n}\n.ticket__icon[data-v-320fc5c8] {\n  right: 23px;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n}\n", ""]);

// exports
